(() => {
  window.addEventListener('load', () => {
    const openToggles = document.querySelectorAll('.open-modal-carousel');
    const modal = document.querySelector('.modal-carousel');
    const carousel = document.querySelector('.product-carousel__slider');
    const slider = window.modalCarousel;

    if (openToggles && modal && slider) {
      openToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          if (modal) {
            const index = window.mediaSlider.realIndex;
            slider.slideTo(index, 0);
            modal.classList.add('modal-carousel--open');
          }
        });
      });

      function resetVideo() {
        const video = slider.slides[slider.realIndex].querySelector('video');
        if (video) {
          video.load();
        }
      }

      modal.addEventListener('click', () => {
        resetVideo();
        modal.classList.remove('modal-carousel--open');
      });

      carousel.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      slider.on('beforeTransitionStart', () => {
        resetVideo();
      });

      window.addEventListener('scroll', () => {
        if (modal.classList.contains('modal-carousel--open')) {
          modal.classList.remove('modal-carousel--open');
        }
      });
    }
  });
})();
